module.exports = __webpack_public_path__ + "img/bp_xlogo.ff54d19c.png";